module.exports = __webpack_public_path__ + "static/admin.f73e08bb.png";